module.exports = __webpack_public_path__ + "static/img/icon-nodata.269f1df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-nodata.png
// module id = 7f22
// module chunks = 0